import API from '@/services/api';
import router from '@/router';

export default {
  fetchSchoolCount() {
    return API().get('schools-count');
  },
  fetchSchoolsExport() {
    return API().get('schools');
  },
  fetchSchools(currentPage, perPage) {
    return API().get('table/schools', {
      params: {
        currentPage,
        perPage,
      },
    });
  },
  fetchClusterSchools(id,currentPage, perPage) {
    return API().get(`table/schools/${id}`, {
      params: {
        currentPage,
        perPage,
      },
    });
  },
  fetchCoordinatorSchools(id) {
    return API().get(`coordinators/${id}/schools`);
  },
  fetchTrainerSchools(id) {
    return API().get(`trainers/${id}/schools`);
  },
  fetchSchoolNames(country) {
    return API().get(`schools/country/${country}`);
  },

  fetchSchoolsByTrainer(params) {
    return API().get(`schools/${params.id}/names`);
  },
  addSchool(params) {
    return API().post('schools', params);
  },
  updateSchool(params) {
    return API().put(`schools/${router.currentRoute.params.id}`, params);
  },
  getSchool(params) {
    return API().get(`schools/${params.id}`);
  },
  fetchSchoolTeachers() {
    return API().get(`schools/${router.currentRoute.params.id}/teachers`);
  },
  addSchoolTeacher(params) {
    return API().post(
      `schools/${router.currentRoute.params.id}/teachers`,
      params
    );
  },
  updateSchoolTeacher(params) {
    return API().put(
      `schools/${router.currentRoute.params.id}/teachers`,
      params
    );
  },
  deleteSchoolTeacher(params) {
    return API().delete(
      `schools/${router.currentRoute.params.id}/teachers/${params.id}`
    );
  },
  fetchSchoolFinancings() {
    return API().get(`schools/${router.currentRoute.params.id}/financing`);
  },
  addSchoolFinancing(params) {
    return API().post(
      `schools/${router.currentRoute.params.id}/financing`,
      params
    );
  },
  updateSchoolFinancing(params) {
    return API().put(
      `schools/${router.currentRoute.params.id}/financing`,
      params
    );
  },

  deleteSchoolFinancing(schoolFinancingId) {
    return API().delete(
      `schools/${router.currentRoute.params.id}/financing/${schoolFinancingId}`,
      schoolFinancingId
    );
  },
  fetchSchoolPopulations() {
    return API().get(`schools/${router.currentRoute.params.id}/populations`);
  },
  addSchoolPopulation(params) {
    return API().post(
      `schools/${router.currentRoute.params.id}/populations`,
      params
    );
  },
  updateSchoolPopulation(params) {
    return API().put(
      `schools/${router.currentRoute.params.id}/populations/${params.id}`,
      params
    );
  },

  deleteSchoolPopulation(schoolPopulationId) {
    return API().delete(
      `schools/${router.currentRoute.params.id}/populations/${schoolPopulationId}`,
      schoolPopulationId
    );
  },
  fetchSchoolStructures() {
    return API().get(`schools/${router.currentRoute.params.id}/structure`);
  },
  fetchSchoolStructure(structureId) {
    return API().get(
      `schools/${router.currentRoute.params.id}/structure/${structureId}`
    );
  },
  addSchoolStructure(params) {
    return API().post(
      `schools/${router.currentRoute.params.id}/structure`,
      params
    );
  },
  updateSchoolStructure(params) {
    return API().put(
      `schools/${router.currentRoute.params.id}/structure/${params.id}`,
      params
    );
  },

  deleteSchoolStructure(id) {
    return API().delete(
      `schools/${router.currentRoute.params.id}/structure/${id}`
    );
  },
  fetchSchoolsByCountry(params) {
    return API().get(`schools/country/${params.country}`);
  },
  fetchSchoolsByCountryRegion(params) {
    return API().get(
      `schools/country/${params.country}/region/${params.region}`
    );
  },
  fetchSchoolsByCountryRegionDistrict(params) {
    return API().get(
      `schools/country/${params.country}/region/${params.region}/district/${params.district}`
    );
  },
  fetchSchoolsByCountryRegionDistrictVillage(params) {
    return API().get(
      `schools/country/${params.country}/region/${params.region}/district/${params.district}/village/${params.village}`
    );
  },
  fetchSchoolsByCountryVillage(params) {
    return API().get(
      `schools/country/${params.country}/village/${params.village}`
    );
  },
  fetchSchoolsByVillage(params) {
    return API().get(`schools/village/${params.village}`);
  },
};
